// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Up-z","slideIn":"Vp-z"};